import { render, staticRenderFns } from "./PayRecord.vue?vue&type=template&id=5c27e90e&scoped=true&"
import script from "./PayRecord.vue?vue&type=script&lang=js&"
export * from "./PayRecord.vue?vue&type=script&lang=js&"
import style0 from "./PayRecord.vue?vue&type=style&index=0&id=5c27e90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c27e90e",
  null
  
)

export default component.exports